import { Action, SIGNED_OUT_USER } from "../actions";
import { IAccount, ICard, IClaimTemplateDetail, IPerson, ITransaction } from "../../API/DataManagementTypes";
import { combineReducers, Reducer } from "redux";
import { FLUSH_RESULTS } from "./ApiManagementProductionReducer/ApiManagementProductionReducers";
import { GenericState } from "../reduxTypes";

const GET_RANDOM_PERSONS = "GET_RANDOM_PERSONS";
const RESERVE_PERSON = "RESERVE_PERSON";
const GET_RESERVED_PERSONS = "GET_RESERVED_PERSONS";
const GET_RESERVED_PERSON = "GET_RESERVED_PERSON";
const GENERATE_DATA = "GENERATE_DATA";
const GET_ACCOUNTS = "GET_ACCOUNTS";
const GET_ACCOUNT = "GET_ACCOUNT";
const GET_TRANSACTIONS = "GET_TRANSACTIONS";
const GET_CARDS = "GET_CARDS";
const GET_CARD = "GET_CARD";
const GET_CARD_TRANSACTIONS = "GET_CARD_TRANSACTIONS";
const DELETE_ENTRY = "DELETE_ENTRY";
 const UNRESERVE_USER = "UNRESERVE_USER";
const GET_CLAIM_TEMPLATES = "GET_CLAIM_TEMPLATES";
const CREATE_CLAIM_TEMPLATE = "CREATE_CLAIM_TEMPLATE";

export const dataManagementActions = {
  GET_RANDOM_PERSONS,
  RESERVE_PERSON,
  GET_RESERVED_PERSONS,
  GET_RESERVED_PERSON,
  GENERATE_DATA,
  GET_ACCOUNTS,
  GET_ACCOUNT,
  GET_TRANSACTIONS,
  GET_CARDS,
  GET_CARD,
  GET_CARD_TRANSACTIONS,
  DELETE_ACCOUNT: DELETE_ENTRY,
  UNRESERVE_USER,
  GET_CLAIM_TEMPLATES,
  CREATE_CLAIM_TEMPLATE,
};

export interface FakePersonState {
  randomPersons: IPerson[] | undefined;
  error: boolean;
  loading: boolean;
}

export const initialFakePersonState: FakePersonState = {
  randomPersons: undefined,
  error: false,
  loading: false,
};

const fakePersonReducer = (state = initialFakePersonState, action: Action) => {
  switch (action.type) {
    case `${GET_RANDOM_PERSONS}_PENDING`:
      return { ...state, randomPersonsError: false, loading: true };
    case `${GET_RANDOM_PERSONS}_FULFILLED`:
      return { ...state, randomPersons: action.payload, randomPersonsError: false, loading: false };
    case `${GET_RANDOM_PERSONS}_REJECTED`:
      return { ...state, randomPersonsError: true, loading: false };
    case SIGNED_OUT_USER:
      return initialFakePersonState;
    default:
      return state;
  }
};

export interface ReservationState {
  loading: boolean;
  error: boolean;
  result: any;
  apiError?: any;
}

export const initialReservationState: ReservationState = {
  loading: false,
  error: false,
  result: null,
  apiError: undefined,
};

const reservationReducer = (state = initialReservationState, action: Action) => {
  switch (action.type) {
    case `${RESERVE_PERSON}_PENDING`:
      return { ...state, loading: true, error: false, apiError: undefined };
    case `${RESERVE_PERSON}_FULFILLED`:
      return { ...state, result: action.payload, loading: false, error: false, apiError: undefined };
    case `${RESERVE_PERSON}_REJECTED`:
      return { ...state, loading: false, error: true, apiError: action.payload };
    case SIGNED_OUT_USER:
      return initialReservationState;
    default:
      return state;
  }
};

const reservedFakePersonReducer = (state = initialFakePersonState, action: Action) => {
  switch (action.type) {
    case `${GET_RESERVED_PERSONS}_PENDING`:
      return { ...state, randomPersonsError: false, loading: true };
    case `${GET_RESERVED_PERSONS}_FULFILLED`:
      return { ...state, randomPersons: action.payload, randomPersonsError: false, loading: false };
    case `${GET_RESERVED_PERSONS}_REJECTED`:
      return { ...state, randomPersonsError: true, loading: false };
    case SIGNED_OUT_USER:
      return initialFakePersonState;
    default:
      return state;
  }
};

export interface FakeIndividualState {
  person: IPerson | undefined;
  loading: boolean;
  error: boolean;
}
export const initialFakeIndividualState: FakeIndividualState = {
  person: undefined,
  loading: false,
  error: false,
};

const reservedFakeIndividualReducer = (state = initialFakeIndividualState, action: Action) => {
  switch (action.type) {
    case `${GET_RESERVED_PERSON}_PENDING`:
      return { ...state, error: false, loading: true };
    case `${GET_RESERVED_PERSON}_FULFILLED`:
      return { ...state, person: action.payload, error: false, loading: false };
    case `${GET_RESERVED_PERSON}_REJECTED`:
      return { ...state, error: true, loading: false };
    case SIGNED_OUT_USER:
      return initialFakeIndividualState;
    default:
      return state;
  }
};

export interface AccountsState {
  accounts: IAccount[] | undefined;
  loading: boolean;
  error: boolean;
}

export const initialAccountsState: AccountsState = {
  accounts: undefined,
  loading: false,
  error: false,
};

const accountsReducer = (state = initialAccountsState, action: Action) => {
  switch (action.type) {
    case `${GET_ACCOUNTS}_PENDING`:
      return { ...state, error: false, loading: true };
    case `${GET_ACCOUNTS}_FULFILLED`:
      return { ...state, accounts: action.payload, error: false, loading: false };
    case `${GET_ACCOUNTS}_REJECTED`:
      return { ...state, error: true, loading: false };
    case SIGNED_OUT_USER:
      return initialAccountsState;
    default:
      return state;
  }
};

export interface AccountState {
  account: IAccount | undefined;
  loading: boolean;
  error: boolean;
}

export const initialAccountState: AccountState = {
  account: undefined,
  loading: false,
  error: false,
};

const accountReducer = (state = initialAccountState, action: Action) => {
  switch (action.type) {
    case `${GET_ACCOUNT}_PENDING`:
      return { ...state, error: false, loading: true };
    case `${GET_ACCOUNT}_FULFILLED`:
      return { ...state, account: action.payload, error: false, loading: false };
    case `${GET_ACCOUNT}_REJECTED`:
      return { ...state, error: true, loading: false };
    case SIGNED_OUT_USER:
      return initialAccountState;
    default:
      return state;
  }
};

export type DeleteEntryState = GenericState<{type: string} | undefined>;
const initialDeleteEntryState = {
  error: false,
  loading: false,
  data: undefined,
};

const deleteAccountReducer = (state = initialDeleteEntryState, action: Action) => {
  switch (action.type) {
    case `${DELETE_ENTRY}_PENDING`:
      return { ...state, error: false, loading: true };
    case `${DELETE_ENTRY}_FULFILLED`:
      return { ...state, data: action.payload, error: false, loading: false };
    case `${DELETE_ENTRY}_REJECTED`:
      return { ...state, error: true, loading: false };
    case FLUSH_RESULTS:
      return initialDeleteEntryState;
    case SIGNED_OUT_USER:
      return initialDeleteEntryState;
    default:
      return state;
  }
};

export interface GenerationState {
  loading: boolean;
  error: boolean;
  result: any;
}

export const initialGenerationState: GenerationState = {
  loading: false,
  error: false,
  result: undefined,
};

const generationReducer = (state = initialReservationState, action: Action) => {
  switch (action.type) {
    case `${GENERATE_DATA}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GENERATE_DATA}_FULFILLED`:
      return { ...state, result: action.payload, loading: false, error: false };
    case `${GENERATE_DATA}_REJECTED`:
      return { ...state, loading: false, error: true };
    case SIGNED_OUT_USER:
      return initialReservationState;
    default:
      return state;
  }
};

export interface TransactionState {
  loading: boolean;
  error: boolean;
  result: ITransaction[] | undefined;
}

export const initialTransactionState: TransactionState = {
  loading: false,
  error: false,
  result: undefined,
};

const transactionReducer = (state = initialTransactionState, action: Action) => {
  switch (action.type) {
    case `${GET_TRANSACTIONS}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GET_TRANSACTIONS}_FULFILLED`:
      return { ...state, result: action.payload, loading: false, error: false };
    case `${GET_TRANSACTIONS}_REJECTED`:
      return { ...state, loading: false, error: true };
    case SIGNED_OUT_USER:
      return initialTransactionState;
    default:
      return state;
  }
};


const unreserveReducer = (state = initialGenerationState, action: Action) => {
  switch (action.type) {
    case `${UNRESERVE_USER}_PENDING`:
      return { ...state, loading: true, error: false, result: null };
    case `${UNRESERVE_USER}_FULFILLED`:
      return { ...state, result: "unreserved", loading: false, error: false };
    case `${UNRESERVE_USER}_REJECTED`:
      return { ...state, loading: false, error: true, result: null };
    case SIGNED_OUT_USER:
      return initialGenerationState;
    default:
      return state;
  }
};

export type CardsState = GenericState<ICard[] | undefined>;
const initialCardsState = {
  error: false,
  loading: false,
  data: undefined,
};

function cardsReducer(state = initialCardsState, action: Action) {
  switch (action.type) {
    case `${GET_CARDS}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GET_CARDS}_FULFILLED`:
      return { ...state, data: action.payload, loading: false, error: false };
    case `${GET_CARDS}_REJECTED`:
      return { ...state, loading: false, error: true };
    case SIGNED_OUT_USER:
      return initialCardsState;
    default:
      return state;
  }
}

export type CardState = GenericState<ICard | undefined>;

function cardReducer(state = initialCardsState, action: Action) {
  switch (action.type) {
    case `${GET_CARD}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GET_CARD}_FULFILLED`:
      return { ...state, data: action.payload, loading: false, error: false };
    case `${GET_CARD}_REJECTED`:
      return { ...state, loading: false, error: true };
    case SIGNED_OUT_USER:
      return initialCardsState;
    default:
      return state;
  }
}

function cardTransactionReducer(state = initialTransactionState, action: Action) {
  switch (action.type) {
    case `${GET_CARD_TRANSACTIONS}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GET_CARD_TRANSACTIONS}_FULFILLED`:
      return { ...state, result: action.payload, loading: false, error: false };
    case `${GET_CARD_TRANSACTIONS}_REJECTED`:
      return { ...state, loading: false, error: true };
    case SIGNED_OUT_USER:
      return initialTransactionState;
    default:
      return state;
  }
}

export interface ClaimTemplatesState {
  loading: boolean;
  error: boolean;
  templates: IClaimTemplateDetail[] | undefined;
}

export const initialClaimTemplatesState: ClaimTemplatesState = {
  loading: false,
  error: false,
  templates: undefined,
};

function claimTemplatesReducer(state = initialClaimTemplatesState, action: Action): ClaimTemplatesState {
  switch (action.type) {
    case `${GET_CLAIM_TEMPLATES}_PENDING`:
      return { ...state, loading: true, error: false };
    case `${GET_CLAIM_TEMPLATES}_FULFILLED`:
      return { ...state, templates: action.payload, loading: false, error: false };
    case `${GET_CLAIM_TEMPLATES}_REJECTED`:
      return { ...state, loading: false, error: true };
    case `${CREATE_CLAIM_TEMPLATE}_FULFILLED`: {
      if (!action.payload?.templateCode) return state;
      const newTemplate: IClaimTemplateDetail = {
        templateCode: action.payload.templateCode,
        bankBranch: action.payload.bankBranch,
        createdAt: new Date().toISOString(),
      };
      return { ...state, templates: [...(state.templates ?? []), newTemplate] };
    }
    case SIGNED_OUT_USER:
      return initialClaimTemplatesState;
    default:
      return state;
  }
}

export interface CreateClaimTemplateState {
  loading: boolean;
  error: boolean;
  result: { templateCode: string; bankBranch: string } | undefined;
}

export const initialCreateClaimTemplateState: CreateClaimTemplateState = {
  loading: false,
  error: false,
  result: undefined,
};

function createClaimTemplateReducer(state = initialCreateClaimTemplateState, action: Action): CreateClaimTemplateState {
  switch (action.type) {
    case `${CREATE_CLAIM_TEMPLATE}_PENDING`:
      return { ...state, loading: true, error: false, result: undefined };
    case `${CREATE_CLAIM_TEMPLATE}_FULFILLED`:
      return { ...state, result: action.payload, loading: false, error: false };
    case `${CREATE_CLAIM_TEMPLATE}_REJECTED`:
      return { ...state, loading: false, error: true, result: undefined };
    case SIGNED_OUT_USER:
      return initialCreateClaimTemplateState;
    default:
      return state;
  }
}
export interface DataManagementState {
  fakePersonData: FakePersonState;
  reservation: ReservationState;
  reservedPersonData: FakePersonState;
  reservedIndividual: FakeIndividualState;
  unreservedResult: GenerationState;
  accounts: AccountsState;
  selectedAccount: AccountState;
  deleteEntryResult: DeleteEntryState;
  generationResult: GenerationState;
  transactions: TransactionState;
  cards: CardsState;
  selectedCard: CardState;
  cardTransactions: TransactionState;
  claimTemplates: ClaimTemplatesState;
  createClaimTemplate: CreateClaimTemplateState;
}

export const dataManagementReducers: Reducer<DataManagementState> = combineReducers({
  fakePersonData: fakePersonReducer,
  reservation: reservationReducer,
  reservedPersonData: reservedFakePersonReducer,
  reservedIndividual: reservedFakeIndividualReducer,
  accounts: accountsReducer,
  selectedAccount: accountReducer,
  deleteEntryResult: deleteAccountReducer,
  generationResult: generationReducer,
  transactions: transactionReducer,
  unreservedResult: unreserveReducer,
  cards: cardsReducer,
  selectedCard: cardReducer,
  cardTransactions: cardTransactionReducer,
  claimTemplates: claimTemplatesReducer,
  createClaimTemplate: createClaimTemplateReducer,
});
